export function readColumnVisibility(key?: string): Record<string, boolean> {
  if (!key) return {};
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) || '{}');
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    return Object.fromEntries(Object.entries(value).filter(([, visible]) => typeof visible === 'boolean'));
  } catch {
    return {};
  }
}
export function saveColumnVisibility(key: string | undefined, value: Record<string, boolean>) {
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* Storage may be unavailable. */
  }
}
